// import { stringify } from 'query-string'
import { GENERIC_ACTION } from '../SearchResults/logic'

const GET_HISTORY_CHANGE_DATA = 'GET_HISTORY_CHANGE_DATA'
const GET_HISTORY_CHANGE_DATA_SUCCESS = 'GET_HISTORY_CHANGE_DATA_SUCCESS'
const GET_HISTORY_CHANGE_DATA_FAILURE = 'GET_HISTORY_CHANGE_DATA_FAILURE'

const INITIAL_STATE = {
  data: {},
  loading: false,
  error: false,
  flag: false,
}
export const getHistoryChangeDataAction = (payload, meta = {}) => ({
  type: GENERIC_ACTION,
  payload,
  meta: {
    actionType: GET_HISTORY_CHANGE_DATA,
    url: `${process.env.apiUrl}/v0/search/historyChangeData`,
    method: 'GET',
    auth: true,
    // customHeaders: { 'Content-Type': undefined },
    log: false, // for console
    ...meta,
  },
  showNotification: false, // show notification on success
  hideNotification: false, // hide notification on error
})

export function getHistoryChangeDataReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_HISTORY_CHANGE_DATA: {
      return {
        data: {},
        loading: true,
        flag: true,
        error: false,
      }
    }
    case GET_HISTORY_CHANGE_DATA_SUCCESS: {
      return {
        data: action.payload,
        loading: false,
        flag: true,
        error: false,
      }
    }
    case GET_HISTORY_CHANGE_DATA_FAILURE: {
      return {
        data: {},
        loading: false,
        flag: false,
        error: true,
      }
    }
    default:
      return state
  }
}
